// extracted by mini-css-extract-plugin
export default {"sidePanel":"MapSidebar_sidePanel__-GGVw","sidebarItemTitle":"MapSidebar_sidebarItemTitle__7XoCs","hasMargins":"MapSidebar_hasMargins__qjQty"};